import { render, staticRenderFns } from "./teacherCourseWare.vue?vue&type=template&id=20b4b761&scoped=true&"
import script from "./teacherCourseWare.vue?vue&type=script&lang=js&"
export * from "./teacherCourseWare.vue?vue&type=script&lang=js&"
import style0 from "./teacherCourseWare.vue?vue&type=style&index=0&id=20b4b761&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4b761",
  null
  
)

export default component.exports